import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);
const SUPPORTED = ["es", "en", "it"];

function detectLang() {
  const stored = localStorage.getItem("cm_lang");
  if (stored && SUPPORTED.includes(stored)) return stored;
  return "es"; // default language is Spanish
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    localStorage.setItem("cm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (SUPPORTED.includes(l)) setLangState(l);
  }, []);

  const t = useCallback((key) => {
    const parts = key.split(".");
    let node = translations[lang];
    let fallback = translations.es;
    for (const p of parts) {
      node = node?.[p];
      fallback = fallback?.[p];
    }
    return (node ?? fallback ?? key);
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: SUPPORTED }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export const LANG_LABELS = { es: "🇪🇸 Español", en: "🇬🇧 English", it: "🇮🇹 Italiano" };
